module.exports = __webpack_public_path__ + "static/img/green products card_04.954957b0.jpg";